(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[854],{

/***/ 7980:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ imageDataToMetaTags; }
/* harmony export */ });
var ogResolution = '/dynamic/1200x840/';
var twitterResolution = '/dynamic/1000x1000/';
var resolutionToReplace = '/dynamic/1600w/';
var imageDataToMetaTags = function imageDataToMetaTags(imageData) {
  if (imageData !== null && imageData !== void 0 && imageData.src) {
    return {
      og: {
        url: imageData.src.replace(resolutionToReplace, ogResolution),
        description: imageData.description
      },
      twitter: {
        url: imageData.src.replace(resolutionToReplace, twitterResolution)
      }
    };
  } else {
    return null;
  }
};

/***/ }),

/***/ 9862:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _home_travis_build_finn_travel_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5235);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9051);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(314);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_config__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var shared_page_Head__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(262);
/* harmony import */ var shared_page_Main__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9530);
/* harmony import */ var _lib_helpers_imageDataToMetaTags__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(7980);
/* harmony import */ var _lib_helpers_strings__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(7521);
/* harmony import */ var _scenes_objectPage_ObjectPage__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1666);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2322);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_home_travis_build_finn_travel_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck













var _getConfig = next_config__WEBPACK_IMPORTED_MODULE_4___default()(),
    broadcastUrl = _getConfig.publicRuntimeConfig.broadcastUrl;

var Ad = function Ad(props) {
  var _objectData$images;

  var objectData = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function (state) {
    return state.objectData;
  });
  var imageMetaTags = (0,_lib_helpers_imageDataToMetaTags__WEBPACK_IMPORTED_MODULE_9__/* .imageDataToMetaTags */ .y)((_objectData$images = objectData.images) === null || _objectData$images === void 0 ? void 0 : _objectData$images[0]);
  var truncatedDescription = (0,_lib_helpers_strings__WEBPACK_IMPORTED_MODULE_10__/* .truncateWithEllipsis */ .n)(objectData.description, 200);
  var podlets = JSON.parse(props.podlets);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)(shared_page_Head__WEBPACK_IMPORTED_MODULE_5__/* .Head */ .F, {
      title: "".concat(objectData.heading, " | FINN reise"),
      description: truncatedDescription,
      canonical: "https://www.finn.no/reise/feriehus-hytteutleie/ad.html?finnkode=".concat(objectData.adId),
      imageUrl: imageMetaTags ? imageMetaTags.og.url : undefined,
      podlets: podlets,
      children: [imageMetaTags !== null && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.Fragment, {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("meta", {
          property: "og:image:alt",
          content: imageMetaTags.og.description
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("meta", {
          name: "twitter:image",
          content: imageMetaTags.twitter.url
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("link", {
        rel: "stylesheet",
        href: "https://static.finncdn.no/_c/troika-css/v8.4.25/components/lightbox-gallery.min.css"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("link", {
        rel: "stylesheet",
        href: "https://static.finncdn.no/_c/troika-css/v8.4.25/components/imageformat.min.css"
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(shared_page_Main__WEBPACK_IMPORTED_MODULE_6__/* .Main */ .or, {
      podlets: podlets,
      broadcastUrl: broadcastUrl,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_scenes_objectPage_ObjectPage__WEBPACK_IMPORTED_MODULE_7__/* .ObjectPage */ .r, _objectSpread({}, props))
    })]
  });
};

// Move router into the component using it as a useRouter hook
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = ((0,next_router__WEBPACK_IMPORTED_MODULE_3__.withRouter)(Ad));

/***/ }),

/***/ 4368:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ad.html",
      function () {
        return __webpack_require__(9862);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [663,831,517,856,51,857,467,953,109,530,842,910,774,888,179], function() { return __webpack_exec__(4368); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);